import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { YMark } from "@/components/site/Logo";

import { ForgotPassword } from "./ForgotPassword";

export const AdminLogin = ({ title = "Area staff" }) => {
  const { setUser } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [forgot, setForgot] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setUser(data);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const cls = "mt-2 w-full border-b border-[#1c1418]/30 bg-transparent py-3 text-lg outline-none focus:border-[#1c1418]";
  return (
    <main className="flex min-h-screen items-center justify-center bg-white px-5 pt-20 text-[#1c1418]">
      <form onSubmit={submit} data-testid="admin-login-form" className="w-full max-w-md border border-[#1c1418]/20 p-8">
        <YMark className="h-12 w-12" />
        <h1 className="mt-6 font-display text-6xl uppercase leading-none">{title}<span className="text-[#1c1418]">.</span></h1>
        <label className="mt-8 block font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/70">Email
          <input data-testid="admin-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={cls} />
        </label>
        <label className="mt-6 block font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/70">Password
          <input data-testid="admin-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={cls} />
        </label>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-[#1c1418]">{error}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="mt-8 w-full bg-[#1c1418] py-4 font-mono text-xs uppercase tracking-[0.25em] text-white disabled:opacity-60">
          {busy ? "Accesso…" : "Accedi"}
        </button>
        <button type="button" onClick={() => setForgot(true)} data-testid="forgot-password-link" className="mt-5 block w-full text-center font-mono text-[11px] uppercase tracking-[0.2em] underline">
          Password dimenticata?
        </button>
      </form>
      {forgot && <ForgotPassword onClose={() => setForgot(false)} defaultEmail={email} />}
    </main>
  );
};
